import { useEffect, useState } from 'react';

// Known point types from NOMBRE_OPTIONS
const KNOWN_PUNTO_CONFIG = {
  casa: {
    label: 'Casa',
    color: '#8B4513',
    symbol: `<path d="M12 3L4 10v9h5v-5h6v5h5V10L12 3z" fill="white"/>`,
  },
  pozoagua: {
    label: 'Pozo de agua',
    color: '#1565C0',
    symbol: `<ellipse cx="12" cy="14" rx="5" ry="6" fill="white" opacity="0.9"/><path d="M12 4 Q8 9 12 12 Q16 9 12 4z" fill="white"/>`,
  },
  almacen: {
    label: 'Almacén',
    color: '#546E7A',
    symbol: `<rect x="5" y="10" width="14" height="9" fill="white"/><polygon points="3,11 12,4 21,11" fill="white" opacity="0.8"/>`,
  },
  beneficio: {
    label: 'Beneficio',
    color: '#2E7D32',
    symbol: `<circle cx="12" cy="12" r="3" fill="white"/><path d="M12 7v2M12 15v2M7 12h2M15 12h2M8.6 8.6l1.4 1.4M14 14l1.4 1.4M8.6 15.4l1.4-1.4M14 10l1.4-1.4" stroke="white" stroke-width="2" stroke-linecap="round"/>`,
  },
  patiosecado: {
    label: 'Patio de secado',
    color: '#F57F17',
    symbol: `<circle cx="12" cy="12" r="3.5" fill="white"/><path d="M12 5v2M12 17v2M5 12h2M17 12h2M7.1 7.1l1.4 1.4M15.5 15.5l1.4 1.4M7.1 16.9l1.4-1.4M15.5 8.5l1.4-1.4" stroke="white" stroke-width="2" stroke-linecap="round"/>`,
  },
  'cuarto de empaque': {
    label: 'Cuarto de empaque',
    color: '#00838F',
    symbol: `<rect x="5" y="8" width="14" height="11" rx="1" fill="white"/><path d="M5 11h14M9 8v3M15 8v3" stroke="#00838F" stroke-width="1.5"/>`,
  },
  vivero: {
    label: 'Vivero',
    color: '#388E3C',
    symbol: `<path d="M12 17 Q12 12 12 9" stroke="white" stroke-width="2"/><path d="M12 12 Q8 10 7 7 Q10 7 12 9" fill="white" opacity="0.9"/><path d="M12 10 Q16 8 17 5 Q14 5 12 7" fill="white" opacity="0.9"/>`,
  },
  iglesia: {
    label: 'Iglesia',
    color: '#6A4C93',
    symbol: `<rect x="11" y="3" width="2" height="7" fill="white"/><rect x="8.5" y="5.5" width="7" height="2" fill="white"/><path d="M5 21v-7l7-4 7 4v7H5z" fill="white" opacity="0.85"/>`,
  },
  escuela: {
    label: 'Escuela',
    color: '#1976D2',
    symbol: `<path d="M12 4L2 9l10 5 8-4v6h2V9L12 4z" fill="white"/><path d="M6 12v4.5c0 1.4 2.7 3 6 3s6-1.6 6-3V12l-6 3-6-3z" fill="white" opacity="0.85"/>`,
  },
  panteón: {
    label: 'Panteón',
    color: '#546E7A',
    symbol: `<rect x="11" y="4" width="2" height="9" fill="white"/><rect x="8" y="7" width="8" height="2" fill="white"/><path d="M6 20c0-3 2.5-5 6-5s6 2 6 5H6z" fill="white" opacity="0.85"/>`,
  },
  'centro de población': {
    label: 'Centro de población',
    color: '#8D6E63',
    symbol: `<path d="M4 20v-6l3-3 3 3v6H4z" fill="white" opacity="0.8"/><path d="M11 20v-8l4-4 4 4v8h-8z" fill="white"/>`,
  },
  camino: {
    label: 'Camino',
    color: '#9E9E9E',
    symbol: `<path d="M9 3 6 21M15 3l3 18" stroke="white" stroke-width="1.8" stroke-linecap="round" fill="none"/><path d="M12 4v3M12 10.5v3M12 17v3" stroke="white" stroke-width="1.8" stroke-linecap="round"/>`,
  },
  terracería: {
    label: 'Terracería',
    color: '#D87748',
    symbol: `<path d="M9 3 6 21M15 3l3 18" stroke="white" stroke-width="1.8" stroke-linecap="round" fill="none" stroke-dasharray="2.5,2.5"/>`,
  },
  puente: {
    label: 'Puente',
    color: '#455A64',
    symbol: `<path d="M3 17c2.5-5 6-7.5 9-7.5S18.5 12 21 17" stroke="white" stroke-width="2" fill="none" stroke-linecap="round"/><line x1="3" y1="17" x2="3" y2="20" stroke="white" stroke-width="2" stroke-linecap="round"/><line x1="21" y1="17" x2="21" y2="20" stroke="white" stroke-width="2" stroke-linecap="round"/><line x1="3" y1="19" x2="21" y2="19" stroke="white" stroke-width="2" stroke-linecap="round"/>`,
  },
  potrero: {
    label: 'Potrero',
    color: '#7CB342',
    symbol: `<path d="M4 9v11M9 7v13M15 7v13M20 9v11M3 12h18M3 17h18" stroke="white" stroke-width="1.6" stroke-linecap="round"/>`,
  },
  cerca: {
    label: 'Cerca',
    color: '#795548',
    symbol: `<path d="M4 9v11M9 7v13M15 7v13M20 9v11M3 12h18M3 17h18" stroke="white" stroke-width="1.6" stroke-linecap="round"/>`,
  },
  otro: {
    label: 'Otro',
    color: '#607D8B',
    symbol: `<circle cx="12" cy="12" r="4" fill="white"/>`,
  },
};

KNOWN_PUNTO_CONFIG['almacén'] = { ...KNOWN_PUNTO_CONFIG.almacen, label: 'Almacén' };
KNOWN_PUNTO_CONFIG['beneficio húmedo'] = { ...KNOWN_PUNTO_CONFIG.beneficio, label: 'Beneficio húmedo' };
KNOWN_PUNTO_CONFIG['patio de secado'] = { ...KNOWN_PUNTO_CONFIG.patiosecado, label: 'Patio de secado' };

// Fallback color palette for unknown nombres — cycles through these
const FALLBACK_COLORS = ['#C62828', '#AD1457', '#6A1B9A', '#283593', '#00695C', '#E65100', '#4E342E', '#37474F', '#558B2F', '#00838F'];

const makeSvgIcon = (color, symbol) => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="11" fill="${color}" stroke="white" stroke-width="1.5"/>
    ${symbol}
  </svg>`;
  return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
};

const makeFallbackIcon = color => {
  const symbol = `<circle cx="12" cy="12" r="4" fill="white"/>`;
  return makeSvgIcon(color, symbol);
};

export const LINE_STYLES = [
  { color: '#1565C0', weight: 3, dashType: 'solid', label: 'Línea 1' },
  { color: '#E65100', weight: 3, dashType: 'dashed', label: 'Línea 2' },
  { color: '#5D4037', weight: 3, dashType: 'dotted', label: 'Línea 3' },
  { color: '#2E7D32', weight: 3, dashType: 'dashdot', label: 'Línea 4' },
  { color: '#B71C1C', weight: 2, dashType: 'dashed', label: 'Línea 5' },
  { color: '#37474F', weight: 3, dashType: 'solid', label: 'Línea 6' },
  { color: '#7B1FA2', weight: 2, dashType: 'dotted', label: 'Línea 7' },
  { color: '#00838F', weight: 3, dashType: 'dashdot', label: 'Línea 8' },
];

export const POLYGON_FILLS = [
  { fill: '#FF8F00', stroke: '#E65100' },
  { fill: '#388E3C', stroke: '#1B5E20' },
  { fill: '#1565C0', stroke: '#0D47A1' },
  { fill: '#7B1FA2', stroke: '#4A148C' },
  { fill: '#C62828', stroke: '#B71C1C' },
  { fill: '#00838F', stroke: '#006064' },
];

export const buildPolylineIcons = (maps, dashType) => {
  if (dashType === 'solid') return [];
  if (dashType === 'dashed') {
    return [
      {
        icon: { path: 'M 0,-1 0,1', strokeOpacity: 1, scale: 3 },
        offset: '0',
        repeat: '15px',
      },
    ];
  }
  if (dashType === 'dotted') {
    return [
      {
        icon: { path: maps.SymbolPath.CIRCLE, fillOpacity: 1, strokeOpacity: 0, scale: 2 },
        offset: '0',
        repeat: '10px',
      },
    ];
  }
  if (dashType === 'dashdot') {
    return [
      {
        icon: { path: 'M 0,-1 0,1', strokeOpacity: 1, scale: 3 },
        offset: '0',
        repeat: '20px',
      },
      {
        icon: { path: maps.SymbolPath.CIRCLE, fillOpacity: 1, strokeOpacity: 0, scale: 2 },
        offset: '10px',
        repeat: '20px',
      },
    ];
  }
  return [];
};

const LEGACY_PUNTO_COLOR = '#4a6700';

export const OTRO_PUNTO_DEFAULT_COLOR = KNOWN_PUNTO_CONFIG.otro.color;

export const isCustomPuntoColor = color => !!color && String(color).toLowerCase() !== LEGACY_PUNTO_COLOR;

const isPuntoPersonalizable = nombre => {
  const key = (nombre || '').toLowerCase().trim();
  return key === 'otro' || !KNOWN_PUNTO_CONFIG[key];
};

// Returns icon data URI and label for a punto by nombre
export const getPuntoConfig = (nombre, fallbackIndex, customColor = null) => {
  const key = (nombre || '').toLowerCase().trim();
  const override = isPuntoPersonalizable(nombre) && isCustomPuntoColor(customColor) ? customColor : null;
  const cfg = KNOWN_PUNTO_CONFIG[key];
  if (cfg) {
    const color = override || cfg.color;
    return {
      label: cfg.label,
      color,
      isCustomColor: !!override,
      iconUrl: makeSvgIcon(color, cfg.symbol),
    };
  }
  // Unknown nombre: use fallback color cycle, capitalize the raw nombre as label
  const color = override || FALLBACK_COLORS[fallbackIndex % FALLBACK_COLORS.length];
  return {
    label: nombre || 'Punto',
    color,
    isCustomColor: !!override,
    iconUrl: makeFallbackIcon(color),
  };
};

export const getLineStyle = (maps, index) => {
  const style = LINE_STYLES[index % LINE_STYLES.length];
  return {
    ...style,
    strokeOpacity: style.dashType === 'solid' ? 1 : 0,
    icons: buildPolylineIcons(maps, style.dashType),
  };
};

export const getPolygonFill = index => POLYGON_FILLS[index % POLYGON_FILLS.length];

const resolveLineStyle = (maps, punto, index) => {
  if (punto.color) {
    const dashType = punto.forma_linea || 'solid';
    return {
      color: punto.color,
      weight: 3,
      dashType,
      strokeOpacity: dashType === 'solid' ? 1 : 0,
      icons: buildPolylineIcons(maps, dashType),
    };
  }
  return getLineStyle(maps, index);
};

const resolvePolygonFill = (punto, index) => {
  if (punto.color) {
    return { fill: punto.color, stroke: punto.color };
  }
  return getPolygonFill(index);
};

const toLatLng = c =>
  c && Number.isFinite(Number(c.lat)) && Number.isFinite(Number(c.lng)) ? { lat: Number(c.lat), lng: Number(c.lng) } : null;

export const getGeometryPositions = geometry => {
  if (!geometry) return [];
  const list = Array.isArray(geometry) ? geometry : [geometry];
  return list.map(toLatLng).filter(Boolean);
};

export const getGeoPuntoPositions = geoPuntos =>
  (geoPuntos || []).flatMap(p =>
    Array.isArray(p.coordinates) ? getGeometryPositions(p.coordinates) : getGeometryPositions({ lat: p.lat, lng: p.lng })
  );

const useGeoPuntosLayer = (map, maps, geoPuntos) => {
  const [legendData, setLegendData] = useState({ points: [], lines: [], polygons: [], texts: [] });

  useEffect(() => {
    if (!map || !maps || !geoPuntos?.length) {
      setLegendData({ points: [], lines: [], polygons: [], texts: [] });
      return;
    }

    const overlays = [];
    const legendPoints = [];
    const legendLines = [];
    const legendPolygons = [];
    const legendTexts = [];

    let lineIndex = 0;
    let polyIndex = 0;
    let fallbackColorIndex = 0;

    geoPuntos.forEach(punto => {
      if (punto.tipo === 'punto' && punto.lat != null) {
        const config = getPuntoConfig(punto.nombre, fallbackColorIndex, punto.color);
        const isKnown = !!KNOWN_PUNTO_CONFIG[(punto.nombre || '').toLowerCase().trim()];
        if (!isKnown) fallbackColorIndex++;

        const marker = new maps.Marker({
          position: { lat: parseFloat(punto.lat), lng: parseFloat(punto.lng) },
          map,
          title: config.label,
          icon: {
            url: config.iconUrl,
            scaledSize: new maps.Size(28, 28),
            anchor: new maps.Point(14, 14),
          },
        });
        const iw = new maps.InfoWindow({ content: `<b>${config.label}</b>` });
        marker.addListener('click', () => iw.open(map, marker));
        overlays.push(marker);

        // Deduplicate legend by nombre; store id and coords of first occurrence for map centering
        const legendKey = `${punto.nombre}|${config.isCustomColor ? config.color : ''}`;
        if (!legendPoints.find(lp => lp.key === legendKey)) {
          legendPoints.push({
            key: legendKey,
            id: punto.id,
            nombre: punto.nombre,
            config,
            lat: parseFloat(punto.lat),
            lng: parseFloat(punto.lng),
          });
        }
      } else if (punto.tipo === 'linea' && Array.isArray(punto.coordinates)) {
        const style = resolveLineStyle(maps, punto, lineIndex);
        const polyline = new maps.Polyline({
          path: punto.coordinates,
          strokeColor: style.color,
          strokeWeight: style.weight,
          strokeOpacity: style.strokeOpacity,
          icons: style.icons,
          map,
          clickable: false,
        });
        overlays.push(polyline);
        legendLines.push({ id: punto.id, nombre: punto.nombre, style, index: lineIndex, coordinates: punto.coordinates });
        lineIndex++;
        // `area` es el tipo real que devuelve el backend para cooperativas_simbologia /
        // localidades_simbologia / cuentas_simbologia; `poligono` es el que usa parcela_geos_puntos.
      } else if ((punto.tipo === 'poligono' || punto.tipo === 'area') && Array.isArray(punto.coordinates)) {
        const fill = resolvePolygonFill(punto, polyIndex);
        const polygon = new maps.Polygon({
          paths: punto.coordinates,
          strokeColor: fill.stroke,
          strokeWeight: 2,
          fillColor: fill.fill,
          fillOpacity: 0.3,
          map,
          clickable: false,
        });
        overlays.push(polygon);
        legendPolygons.push({ id: punto.id, nombre: punto.nombre, fill, coordinates: punto.coordinates });
        polyIndex++;
      } else if (punto.tipo === 'texto' && punto.lat != null) {
        const labelText = punto.nombre || '';
        const position = new maps.LatLng(parseFloat(punto.lat), parseFloat(punto.lng));

        class TextLabelOverlay extends maps.OverlayView {
          constructor() {
            super();
            this._div = null;
          }
          onAdd() {
            const div = document.createElement('div');
            div.style.position = 'absolute';
            div.style.backgroundColor = 'rgba(255,255,255,0.92)';
            div.style.border = '1px solid #c8d1a0';
            div.style.borderRadius = '6px';
            div.style.padding = '5px 10px';
            div.style.fontSize = '12px';
            div.style.color = '#333';
            div.style.boxShadow = '0 1px 4px rgba(0,0,0,0.18)';
            div.style.whiteSpace = 'nowrap';
            div.style.pointerEvents = 'none';
            div.style.transform = 'translate(-50%, -100%)';
            div.textContent = labelText;
            this._div = div;
            this.getPanes().overlayLayer.appendChild(div);
          }
          draw() {
            const proj = this.getProjection();
            if (!proj || !this._div) return;
            const px = proj.fromLatLngToDivPixel(position);
            this._div.style.left = `${px.x}px`;
            this._div.style.top = `${px.y - 8}px`;
          }
          onRemove() {
            if (this._div && this._div.parentNode) {
              this._div.parentNode.removeChild(this._div);
              this._div = null;
            }
          }
        }

        const overlay = new TextLabelOverlay();
        overlay.setMap(map);
        overlays.push(overlay);
        legendTexts.push({ id: punto.id, nombre: punto.nombre, lat: parseFloat(punto.lat), lng: parseFloat(punto.lng) });
      }
    });

    setLegendData({ points: legendPoints, lines: legendLines, polygons: legendPolygons, texts: legendTexts });

    return () => {
      overlays.forEach(o => o.setMap(null));
    };
  }, [map, maps, geoPuntos]);

  return { legendData };
};

export default useGeoPuntosLayer;
